import React from "react";
import { IconButton, useMediaQuery } from "@mui/material";
import MUICard from "../MUICard/MUICard.component";
import { Icons } from "../../config/MuiIcons.config";
import ProfileMenu from "../ProfileMenu/ProfileMenu";
import { AppTheme } from "../../theme/App.theme";
import SidebarLogo from "../SideBar/SidebarLogo";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

const HeaderV2 = ({ onMenuClick }) => {
  const isMobile = useMediaQuery("(max-width:600px)");
  const navigate = useNavigate();
  return (
    <React.Fragment>
      <MUICard
        padding={0}
        removeDefaultPadding
        className={"w-100"}
        removeBorder
        style={{
          borderBottom: `1px solid ${AppTheme.BORDER_COLOR}`,
          borderRadius: 0,
        }}
      >
        <div
          style={{
            width: "100%",
            boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
            padding: "10px 20px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          {/* Left: Hamburger menu */}
          <div style={{ display: "flex", alignItems: "center", flex: 1 }}>
            <SidebarLogo InSidebar={false} InHeader={true} />
            <IconButton
              onClick={onMenuClick}
              sx={{ mr: 1, color: "#2D3748" }}
              edge="start"
            >
              <Icons.MenuIcon fontSize="medium" />
            </IconButton>
          </div>

          {/* Right: Calendar */}
          {/* <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <IconButton
              onClick={() => navigate("/hindu-calender")}
              sx={{
                //color: AppTheme.PRIMARY_BLACK,
                marginRight: "10px",
              }}
            >
              <Icons.CalendarIcon fontSize="large" />
            </IconButton>
          </div> */}

          {/* Right: Profile */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: isMobile ? 1 : 2,
            }}
          >
            <ProfileMenu />
          </div>
        </div>
      </MUICard>
    </React.Fragment>
  );
};

export default HeaderV2;
